import { Button, Card, Icon } from "@nabble/ui";
import { useState } from "react";
import { Link } from "react-router-dom";
import { accountDataDownloadUrl } from "../../../../api/dataRequests";
import { PRIVACY_PATH } from "../../../../legal/legal";
import { DataRequestsList } from "./DataRequestsList";
import { MakeRequestDialog } from "./MakeRequestDialog";
import { useDataRequests } from "./useDataRequests";

/** My account → Your data: download a copy, and make requests about your personal data (Law 21.719). */
export function DataSection(): React.JSX.Element {
  const { requests, loadError, reload } = useDataRequests();
  const [making, setMaking] = useState(false);

  return (
    <Card id="data" className="nb-setting" padded={false}>
      <div className="nb-setting-row">
        <div>
          <div className="nb-setting-title">Your data</div>
          <p className="nb-setting-desc">Download a copy of the personal data the suite holds about you, in JSON format.</p>
        </div>
        <div className="nb-setting-content" style={{ alignItems: "flex-start" }}>
          <a className="nb-btn nb-btn-secondary" href={accountDataDownloadUrl()} download>
            <Icon name="download" />
            <span>Download my data</span>
          </a>
        </div>
      </div>

      <div className="nb-setting-row is-stacked">
        <div className="nb-setting-head">
          <div>
            <div className="nb-setting-title">Requests about your data</div>
            <p className="nb-setting-desc">
              Under Chilean Law 21.719 you can ask to see, correct or delete your personal data, among other rights. We answer within
              30 calendar days. <Link to={PRIVACY_PATH}>Read the privacy notice</Link>
            </p>
          </div>
          <Button label="Make a request" variant="secondary" size="sm" icon="plus" onClick={() => setMaking(true)} />
        </div>
        <div className="nb-setting-content">
          <DataRequestsList requests={requests} loadError={loadError} onRetry={reload} />
        </div>
      </div>

      {making ? (
        <MakeRequestDialog
          onClose={() => setMaking(false)}
          onSent={() => {
            setMaking(false);
            reload();
          }}
        />
      ) : null}
    </Card>
  );
}
